import { Injectable } from '@angular/core';
import { FiBackendService } from '../../fi-backend/fi-backend.service';
import { LoadingService } from '../../fi-loading/loading.service';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';
import { FiImageSize } from '@fi-shared/types';
import { IChecklist2ImportResult } from '@fi-shared/checklist/fi-checklist2-shared/fi-checklist2-import/fi-checklist2-import';
import { FiChecklist2ImportWarningType } from '@fi-shared/checklist/fi-checklist2-shared/fi-checklist2-import/fi-checklist2-import-enums';

@Injectable()
export class FiChecklist2ImportService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private fiPrintDownloadService: FiPrintDownloadService,
    ) {}

    /*importFromExcelFile(file: File): Promise<IChecklistV2> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        const promise = this.fiBackend.fetchDataPost<IChecklistV2>(
            'Checklist/Checklist2Import/ImportFromExcelFile',
            formData,
            {
                supressErrorMessage: true,
            },
        );
        return this.fiLoading.trackPromise(promise);
    }*/

    importFromObjectStorage(physicalFileName: string, extension: string): Promise<IChecklist2ImportResult> {
        const url = `Checklist/Checklist2Import/ImportFromObjectStorage?physicalFileName=${physicalFileName}&extension=${extension}`;
        const promise = this.fiBackend.fetchDataPost<IChecklist2ImportResult>(url, undefined, {
            //supressErrorMessage: true,
        });
        return this.fiLoading.trackPromise(promise);
    }

    downloadChecklistExcelTemplate(fileName: string) {
        const url = `Checklist/Checklist2Import/GetChecklistExcelTemplate`;
        const promise = this.fiPrintDownloadService.downloadBinaryFile(url, {
            fileName: fileName,
            size: FiImageSize.Original,
        });
        return this.fiLoading.trackPromise(promise);
    }
}
